export default [
  {
    name: 'United States of America',
    acronym: 'USA',
    acronymISO31661: 'US',
    phoneCode: 1,
    currency: 'usd',
    states: [
      { name: 'Alabama', acronym: 'AL' },
      { name: 'Alaska', acronym: 'AK' },
      { name: 'American Samoa', acronym: 'AS' },
      { name: 'Arizona', acronym: 'AZ' },
      { name: 'Arkansas', acronym: 'AR' },
      { name: 'California', acronym: 'CA' },
      { name: 'Colorado', acronym: 'CO' },
      { name: 'Connecticut', acronym: 'CT' },
      { name: 'Delaware', acronym: 'DE' },
      { name: 'Florida', acronym: 'FL' },
      { name: 'Georgia', acronym: 'GA' },
      { name: 'Guam', acronym: 'GU' },
      { name: 'Hawaii', acronym: 'HI' },
      { name: 'Idaho', acronym: 'ID' },
      { name: 'Illinois', acronym: 'IL' },
      { name: 'Indiana', acronym: 'IN' },
      { name: 'Iowa', acronym: 'IA' },
      { name: 'Kansas', acronym: 'KS' },
      { name: 'Kentucky', acronym: 'KY' },
      { name: 'Louisiana', acronym: 'LA' },
      { name: 'Maine', acronym: 'ME' },
      { name: 'Maryland', acronym: 'MD' },
      { name: 'Massachusetts', acronym: 'MA' },
      { name: 'Michigan', acronym: 'MI' },
      { name: 'Minnesota', acronym: 'MN' },
      { name: 'Mississippi', acronym: 'MS' },
      { name: 'Missouri', acronym: 'MO' },
      { name: 'Montana', acronym: 'MT' },
      { name: 'Nebraska', acronym: 'NE' },
      { name: 'Nevada', acronym: 'NV' },
      { name: 'New Hampshire', acronym: 'NH' },
      { name: 'New Jersey', acronym: 'NJ' },
      { name: 'New Mexico', acronym: 'NM' },
      { name: 'New York', acronym: 'NY' },
      { name: 'North Carolina', acronym: 'NC' },
      { name: 'North Dakota', acronym: 'ND' },
      { name: 'Northern Mariana Islands', acronym: 'MP' },
      { name: 'Ohio', acronym: 'OH' },
      { name: 'Oklahoma', acronym: 'OK' },
      { name: 'Oregon', acronym: 'OR' },
      { name: 'Pennsylvania', acronym: 'PA' },
      { name: 'Puerto Rico', acronym: 'PR' },
      { name: 'Rhode Island', acronym: 'RI' },
      { name: 'South Carolina', acronym: 'SC' },
      { name: 'South Dakota', acronym: 'SD' },
      { name: 'Tennessee', acronym: 'TN' },
      { name: 'Texas', acronym: 'TX' },
      { name: 'Utah', acronym: 'UT' },
      { name: 'U.S. Virgin Islands', acronym: 'VI' },
      { name: 'Vermont', acronym: 'VT' },
      { name: 'Virginia', acronym: 'VA' },
      { name: 'Washington', acronym: 'WA' },
      { name: 'Washington D.C.', acronym: 'DC' },
      { name: 'West Virginia', acronym: 'WV' },
      { name: 'Wisconsin', acronym: 'WI' },
      { name: 'Wyoming', acronym: 'WY' },
    ],
  },
  {
    name: 'Canada',
    acronym: 'CAN',
    acronymISO31661: 'CA',
    phoneCode: 1,
    currency: 'cad',
    states: [
      { name: 'Alberta', acronym: 'AB' },
      { name: 'British Columbia', acronym: 'BC' },
      { name: 'Manitoba', acronym: 'MB' },
      { name: 'New Brunswick', acronym: 'NB' },
      { name: 'Newfoundland and Labrador', acronym: 'NL' },
      { name: 'Northwest Territories', acronym: 'NT' },
      { name: 'Nova Scotia', acronym: 'NS' },
      { name: 'Nunavut', acronym: 'NU' },
      { name: 'Ontario', acronym: 'ON' },
      { name: 'Prince Edward Island', acronym: 'PE' },
      { name: 'Quebec', acronym: 'QC' },
      { name: 'Saskatchewan', acronym: 'SK' },
      { name: 'Yukon Territory', acronym: 'YT' },
    ],
  },
];
